export default {
  text: 'Questo ristorante è sospeso. Contatta il tuo referente o scrivici a <a>{{supportEmail}}</a> se desideri ripristinarlo',
};
